import { render, staticRenderFns } from "./StudentName.vue?vue&type=template&id=71fb7580&scoped=true&"
import script from "./StudentName.vue?vue&type=script&lang=js&"
export * from "./StudentName.vue?vue&type=script&lang=js&"
import style0 from "./StudentName.vue?vue&type=style&index=0&id=71fb7580&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "71fb7580",
  null
  
)

export default component.exports